import axiosPrivate from "../axiosPrivate";
import { GET_DOCTOR_URL } from "src/constants";

export const getDoctorById = (email) => {
  return axiosPrivate.get(`${GET_DOCTOR_URL}/?email=${email}`);
};
